import React from 'react'
import classnames from 'classnames'

export default function Icon({ icon, className }) {
  return <i className={classnames('fa', `fa-${icon}`, className)} />
}



// WEBPACK FOOTER //
// client/components/util/Icon.js